// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"qzHbE_sg","loader":"_3YSHEWrz","personaList":"_2Ugv40iT"};